@if (row(); as row) {
    <div class="flex gap-2 items-center">
        <p [class.line-through]="row.discountPrice">
            {{ row.price | number }}₩
        </p>
        <p>
            @if (row.discountPrice) {
                {{ (row.price || 0) - row.discountPrice | number }}₩
            }
        </p>
    </div>
}
